module.exports = __webpack_public_path__ + "static/avatar.85e2e124.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/avatar.png
// module id = 1094
// module chunks = 91538213519978